import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent, reactive, ref, watch } from "vue";
import UpLoadImg from "@/components/UpLoadImg/index.vue";
export default defineComponent({
  name: "Process",
  components: {
    UpLoadImg: UpLoadImg
  },
  props: {
    title: {
      type: String,
      default: "过程描述"
    },
    content: {
      type: String,
      default: ""
    },
    imgUrls: {
      type: String,
      default: ""
    }
  },
  emits: ["update:content", "update:imgUrls", 'getForm'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    // 是否显示文字输入标
    var iconFlag = ref(true); // 监听中文输入开始

    function startInput() {
      iconFlag.value = false;
    } // 监听中文输入结束


    function endInput() {
      iconFlag.value = true;
    }

    var form = reactive({
      content: "",
      imgs: props.imgUrls
    });
    var ruleFormRef = ref(); //表单实例

    var rules = reactive({
      content: [{
        required: true,
        message: "请填写描述",
        trigger: "blur"
      }]
    });
    watch(function () {
      return form.content;
    }, function (val) {
      if (!val) {
        iconFlag.value = true;
      } else {
        iconFlag.value = false;
      }
    }); // 获取上传图片的路径

    function filechange(val) {
      form.imgs = val.join(",");
    }

    function verify() {
      if (!ruleFormRef.value) return false;
      return new Promise(function (resolve) {
        ruleFormRef.value.validate( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid, fields) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (valid) {
                      resolve(form);
                    } else {
                      console.log("error", fields);
                    }

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x, _x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
    }

    return {
      rules: rules,
      form: form,
      ruleFormRef: ruleFormRef,
      iconFlag: iconFlag,
      startInput: startInput,
      endInput: endInput,
      verify: verify,
      filechange: filechange
    };
  }
});